module.exports = __webpack_public_path__ + "img/丽水市.129cc564.png";